import React from "react";
import ControlTemplate from "../BaseControls/ControlTemplate";
import FileField from "../BaseControls/FileField/FileField";
import {controlPropTypes} from "../formhelpers";
import PropTypes from "prop-types";

export default class Manager extends React.Component {
    render() {        
        return (
            <ControlTemplate {...this.props} className="file-field" >
                <FileField {...this.props} />
            </ControlTemplate>
        );
    }
}

Manager.propTypes = {
    ...controlPropTypes({ multiValued: PropTypes.bool }),

    files: PropTypes.arrayOf(
        PropTypes.shape({
            filename: PropTypes.string.isRequired,
            status: PropTypes.string.isRequired,
            progress: PropTypes.number.isRequired,
            filesize: PropTypes.number.isRequired,
        })
    ),

    onFileOpen: PropTypes.func,
    onFileRemove: PropTypes.func,

    // file control properties
    multiValued: PropTypes.bool,

    // html control event methods
    onFileUpload: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/FileField/manager.js